<template>
  <Teleport to=".wrapper-header-toolbar">
    <div class="content-header" id="search-header">
      <div class="w-align-search">
        <nav class="search-type-link" role="navigation" aria-label="Résultats de recherche">
          <ul>
            <!-- Btn Infos -->
            <li class="search-type-container container-link-inform" :class="{'active': type !== 'find'}" v-bind="tabInfosOptions" >
              <a class="link-search link-search-inform" v-if="type === 'find'"
                 :href="'/recherche/s-informer/' + urlWithoutSpaces">Information (<span class="jsTotalResultInfo">{{totalInfoResults}}</span>)</a>
              <span class="link-search link-search-find" v-else>
                Information (<span class="jsTotalResultInfo">{{totalInformationResults}}</span>)
              </span>
            </li>

            <!-- Btn Find -->
            <li class="search-type-container container-link-find" :class="{'active': type === 'find'}" v-bind="tabFindOptions">
              <span class="link-search link-search-find" v-if="type === 'find'">Annuaire (<span class="jsTotalResultFind">{{pagination.totalResult}}</span>) </span>
              <a class="link-search link-search-inform" v-else
                 :href="'/recherche/trouver/' + urlWithoutSpaces">Annuaire (<span class="jsTotalResultFind">{{totalAnnuaireResults }}</span>)</a>
            </li>
          </ul>
        </nav>
      </div>
      <search-bar />
      <div class="block-content-top-menu">
        <button class="toggle-content-menu hidden" aria-label="Outils" aria-expanded="false">Plus</button>
        <ul class="menu">
          <li>
            <Popper
              placement="bottom"
              hover
            >
              <button class="menu-item print-bt tip-bottom popover-init-js"
                      data-viewport=".block-content-top-menu:visible" data-toggle="popover"
                      data-content="<p>Imprimer la liste de résultats</p>"
                      data-original-title="" title="">
                <img class="hide white" src="/themes/custom/santefr/images/print.png" alt="Imprimer">
              </button>
              <template #content>
                <div class="tooltipContent">Imprimer la liste de résultats</div>
              </template>
            </Popper>
          </li>
          <li class="last">
            <Popper
              placement="bottom"
              hover
            >
              <button
                class="menu-item change-font-size increase-font-size tip-bottom popover-init-js"
                data-viewport=".block-content-top-menu:visible" data-toggle="popover"
                data-content="<p>Augmenter la taille du texte</p>" data-original-title=""
                title=""><i class="icon icon-a-plus"><span
                class="sr-only">Augmenter la taille du texte</span></i></button>
               <template #content>
                <div class="tooltipContent">Augmenter la taille du texte</div>
              </template>
            </Popper>
          </li>
          <li>
            <Popper
              placement="bottom"
              hover
            >
              <button
                class="menu-item change-font-size reduce-font-size tip-bottom popover-init-js"
                data-viewport=".block-content-top-menu:visible" data-toggle="popover"
                data-content="<p>Diminuer la taille du texte</p>" data-original-title=""
                title=""><i class="icon icon-a-minus"><span
                class="sr-only">Diminuer la taille du texte</span></i></button>
              <template #content>
                <div class="tooltipContent">Diminuer la taille du texte</div>
              </template>
            </Popper>
          </li>
          <li v-if="displaySharebtn">
            <Popper
              placement="bottom"
              hover
            >
              <button class="menu-item share"
                      aria-expanded="false">
                <i class="icon-social" aria-hidden="true"><span class="sr-only">Partager la page</span></i>
              </button>
              <template #content>
                <div class="dropdown-share">
                  <div>Partager la page</div>
                  <ul>
                    <li>
                      <a href="#"
                         @click.prevent="copyToClipboard()"
                         class="sha-link"
                         data-copy
                      >Copier le lien</a>
                    </li>
                  </ul>
                </div>
              </template>
            </Popper>
          </li>
        </ul>
      </div>
    </div>
  </Teleport>
</template>
<script>
import { computed, onMounted } from 'vue';
import useClipboard from 'vue-clipboard3';
import Popper from 'vue3-popper';

import SearchBar from '../../modules/searchBarHeader/App.vue';

export default {
  name: 'HeaderComponent',
  props: {
    type: {
      type: String,
      default: '',
    },
    what: {
      type: String,
      default: '',
    },
    where: {
      type: String,
      default: '',
    },
    pagination: {
      type: Object,
      default: () => ({}),
    },
    totalAnnuaireResults: {
      type: Number,
      default: 0,
    },
    totalInfoResults: {
      type: Number,
      default: 0,
    },
    totalInformationResults: {
      type: Number,
      default: 0,
    },
    displaySharebtn: {
      type: Boolean,
      default: false,
    },
    cardThematicResult: {
      type: Number,
      default: 0,
    },
    totalcardThematicResult: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Popper,
    SearchBar,
  },

  setup(props) {
    onMounted(() => {
      window.dispatchEvent(new Event('scroll'));
    });
    const urlWithoutSpaces = computed(() => `${encodeURIComponent(props.what)}${props.where ? `/${encodeURIComponent(props.where)}` : ''}`);

    async function copyToClipboard() {
      const { toClipboard } = useClipboard();
      try {
        await toClipboard(window.location.href);
      } catch (e) {
        console.error(e);
      }
    }
    const tabFindOptions = computed(() => ({ ...props.type === 'find' && { 'aria-current': 'page' } }));
    const tabInfosOptions = computed(() => ({ ...props.type !== 'find' && { 'aria-current': 'page' } }));
    return {
      copyToClipboard,
      urlWithoutSpaces,
      tabFindOptions,
      tabInfosOptions,
    };
  },
  updated() {
    document.querySelector('.jsTotalResultFind').innerHTML = this.type === 'info' ? this.totalAnnuaireResults + this.totalcardThematicResult : this.pagination.totalResult + this.cardThematicResult;
    document.querySelector('.jsTotalResultInfo').innerHTML = this.type === 'info' ? this.totalInformationResults : this.totalInfoResults;
  },
};
</script>
